import axios from "axios";
import API_BASE from "./api";

// Fallback used only when the school hasn't configured an academic year yet
// in Settings → Academic Year.
export const computedAcademicYearFallback = () => {
  const y = new Date().getFullYear();
  return `${y}-${y + 1}`;
};

// Resolves the school's configured default academic year (Settings →
// Academic Year), falling back to a computed "this calendar year - next"
// string only if nothing has been configured yet. Use this to pre-fill the
// academicYear field on every "create new ___" form (classes, admission
// forms, fee structures, timetables, materials, ...) so it matches what the
// admin configured once instead of each page silently guessing from
// today's date.
export const fetchDefaultAcademicYear = async () => {
  try {
    const res = await axios.get(`${API_BASE}/settings`);
    return res.data?.academicYear || computedAcademicYearFallback();
  } catch (_) {
    return computedAcademicYearFallback();
  }
};
